// extracted by mini-css-extract-plugin
module.exports = {"message":"AdditionalMessage_message__NnWx6"};